import { Button, FormControl, Grid, InputLabel, Select, Table, TableBody, TableCell
    , TableRow, TextField, Typography, IconButton, Stack, Box } from '@mui/material';
import { Search as IconSearch, AddCircle as IconAddCircle
    , Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPersonaDireccion, removePersonaDireccion, setDatoPersonaDireccion
    , setPersonaDirecciones, setTiposDirecciones, initPersonDirection, defaultPersonaDirecciones } from '../redux/personDirectionSlice';
import UbigeoSearch from './UbigeoSearch';
import DirectionSearch from './DirectionSearch';
import DialogYesNo from './DialogYesNo';
import * as personaService from "../services/personaService";
import * as catalogoService from "../services/catalogoService";

const PersonDirection = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;

    useEffect(() => {
        dispatch(initPersonDirection({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaDirecciones = useSelector((state) => state.personDirection[sliceKey]?.personaDirecciones);
    const tiposDirecciones = useSelector((state) => state.personDirection[sliceKey]?.tiposDirecciones);

    const [verMasUbigeo, setVerMasUbigeo] = useState(false);
    const [openUbigeoSearch, setOpenUbigeoSearch] = useState(false)
    const openCloseUbigeoSearch = () => { setOpenUbigeoSearch(!openUbigeoSearch); }
    const [openDirectionSearch, setOpenDirectionSearch] = useState(false)
    const openCloseDirectionSearch = () => { setOpenDirectionSearch(!openDirectionSearch); }
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectIdItem, setSelectIdItem] = useState(null);
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);

    const fetchPersonaDirecciones = useCallback(async () => {
        const response = await personaService.getsPersonaDireccionView(props.id)

        if (response === null || response.length === 0)
            dispatch(setPersonaDirecciones({sliceKey: sliceKey, data: defaultPersonaDirecciones}));
        else
            dispatch(setPersonaDirecciones({sliceKey: sliceKey, data: response}));
    }, []);

    const fetchTiposDirecciones = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(38)
        dispatch(setTiposDirecciones({sliceKey: sliceKey, data: response}));
    }, []);

    useEffect(() => {
        fetchPersonaDirecciones();
        fetchTiposDirecciones();
    }, []);

    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaDireccion({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    const setSelectUbigeoSearch = (selectUbigeoSearch) => {
        setItemValue(selectNumero, "idDireccion", 0);
        setItemValue(selectNumero, "idUbigeo", selectUbigeoSearch == null ? 0 : selectUbigeoSearch.idUbigeo);
        setItemValue(selectNumero, "resumenUbigeo", selectUbigeoSearch == null ? "" : selectUbigeoSearch.descripcion);
    }
    const setSelectDirectionSearch = (selectDirectionSearch) => {
        setItemValue(selectNumero, "idUbigeo", selectDirectionSearch.idUbigeo);
        setItemValue(selectNumero, "resumenUbigeo", selectDirectionSearch.ubigeo);
        setItemValue(selectNumero, "idDireccion", selectDirectionSearch.id);
        setItemValue(selectNumero, "detalle", selectDirectionSearch.detalle);
        setItemValue(selectNumero, "referencia", selectDirectionSearch.referencia);
    }
    const deletePersonaDireccion = async () => {
        await personaService.deletePersonaDireccion(props.id, selectNumero)
        dispatch(removePersonaDireccion({sliceKey: sliceKey, numero: selectNumero}));
    }

    return (
        <Grid container>
            <Grid item>
                <Box display="flex" alignItems="center">
                    <Typography variant="h7">
                        <Box sx={{ fontWeight: 'bold' }} padding={0}>
                            {"Direcciones (" + (personaDirecciones?.length || 0) + ")"}
                        </Box>
                    </Typography>
                    <IconButton size="small" aria-label="agregar" style={{height: 10}} onClick={() => {
                        dispatch(addPersonaDireccion(sliceKey));
                    }}>
                        <IconAddCircle />
                    </IconButton>
                    <Button size='small' color="primary" onClick={() => { setVerMasUbigeo(!verMasUbigeo) }}>
                        {verMasUbigeo ? "Ver Menos" : "Ver Más"}
                    </Button>
                </Box>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(personaDirecciones)} */}
                <Table size="small">
                    <TableBody>
                        {
                            verMasUbigeo ?
                            personaDirecciones?.map((row, index) => (
                                <TableRow key={row.numero} sx={(theme) => ({
                                    backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                    "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                                })}>
                                    <TableCell>
                                        <Grid container spacing={1} padding={0}>
                                            <Grid item xs={6} sm={2}>
                                                <FormControl required fullWidth>
                                                    <InputLabel htmlFor="input-tipodireccion">Tipo Direccion</InputLabel>
                                                    <Select
                                                        native
                                                        label="Tipo Direccion"
                                                        value={row.idTipoDireccion || 0}
                                                        onChange={(event, newValue) => {
                                                            setItemValue(row.numero, "idTipoDireccion", event.target.value);
                                                        }}
                                                        inputProps={{
                                                            name: 'idTipoDireccion',
                                                            id: 'input-tipodireccion',
                                                        }}
                                                        size="small"
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {tiposDirecciones?.map((row) => (
                                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6} sm={2}>
                                                <Box display="flex" alignItems="center" gap={0}>
                                                    <TextField
                                                        name="resumenUbigeo"
                                                        label="Ubigeo"
                                                        value={row.resumenUbigeo || ""}
                                                        disabled
                                                        fullWidth
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "resumenUbigeo", event.target.value);
                                                        }}
                                                        size="small"
                                                    />
                                                    <IconButton aria-label="Buscar Ubigeo" size='small' onClick={() => {
                                                        setSelectNumero(row.numero);

                                                        openCloseUbigeoSearch()
                                                    }}>
                                                        <IconSearch />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={5}>
                                                <Box display="flex" alignItems="center" gap={0}>
                                                    <TextField
                                                        required
                                                        name="detalle"
                                                        label="Detalle"
                                                        value={row.detalle || ""}
                                                        fullWidth
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "detalle", event.target.value);
                                                        }}
                                                        size="small"
                                                    />
                                                    <IconButton aria-label="Buscar Direccion" size='small' onClick={() => {
                                                        setSelectNumero(row.numero);

                                                        openCloseDirectionSearch()
                                                    }}>
                                                        <IconSearch />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <Box display="flex" alignItems="center" gap={0}>
                                                    <TextField
                                                        name="referencia"
                                                        label="Referencia"
                                                        value={row.referencia || ""}
                                                        fullWidth
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "referencia", event.target.value);
                                                        }}
                                                        size="small"
                                                    />
                                                    <IconButton aria-label="borrar" size='small' onClick={() => {
                                                        dispatch(removePersonaDireccion({sliceKey: sliceKey, numero: row.numero}))
                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            )) :
                            personaDirecciones?.map((row, index) => (
                                <TableRow key={row.numero}  sx={{
                                    ...(index % 2 === 1 && {
                                        backgroundColor: (theme) => theme.palette.action.selected,
                                    }),
                                    "&:last-child td, &:last-child th": {
                                        borderRadius: "0.5em",
                                    },
                                }}>
                                    <TableCell>
                                        <Grid container spacing={1} padding={0}>
                                            <Grid item xs={6} sm={2}>
                                                <FormControl required fullWidth>
                                                    <InputLabel htmlFor="input-tipodireccion">Tipo Direccion</InputLabel>
                                                    <Select
                                                        native
                                                        label="Tipo Direccion"
                                                        value={row.idTipoDireccion || 0}
                                                        onChange={(event, newValue) => {
                                                            setItemValue(row.numero, "idTipoDireccion", event.target.value);
                                                        }}
                                                        inputProps={{
                                                            name: 'idTipoDireccion',
                                                            id: 'input-tipodireccion',
                                                        }}
                                                        size="small"
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {tiposDirecciones?.map((row) => (
                                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={5}>
                                                <TextField
                                                    required
                                                    name="detalle"
                                                    label="Detalle"
                                                    value={row.detalle || ""}
                                                    fullWidth
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "detalle", event.target.value);
                                                    }}
                                                    size="small"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={5}>
                                                <Box display="flex" alignItems="center" gap={0}>
                                                    <TextField
                                                        name="referencia"
                                                        label="Referencia"
                                                        value={row.referencia || ""}
                                                        fullWidth
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "referencia", event.target.value);
                                                        }}
                                                        size="small"
                                                    />
                                                    <IconButton aria-label="borrar" onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(removePersonaDireccion({sliceKey: sliceKey, numero: row.numero}));
                                                        }
                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>

                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Grid>
            <UbigeoSearch open={openUbigeoSearch} openClose={openCloseUbigeoSearch} setSelection={setSelectUbigeoSearch} />
            <DirectionSearch open={openDirectionSearch} openClose={openCloseDirectionSearch} setSelection={setSelectDirectionSearch} />
            <DialogYesNo open={openDialogDelete} openClose={openCloseDialogDelete} setYes={deletePersonaDireccion} 
                setNo={() => { return }}
                titulo={"Borrar dirección"}
                texto={"Esta seguro de borrar la dirección?"} >
            </DialogYesNo>
        </Grid>
    )
}

export default PersonDirection;
